import template from './add_approval_structure.html';
import tr from '../../lib/default-translator.js';

class AddApprovalStructureViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.employees = ko.observableArray(); 
		this.priority = ko.observable(1)
		this.editable = ko.observable(false); 
		this.approval_structure_line_id = ko.observable(); 

		this.current_employee_id = ko.observable();
		this.selected_employee = ko.observable();
		this.search_string = ko.observable();
		this.project_name = ko.observable();
		this.task_id = ko.observable();
		this.projects = ko.observableArray();
		this.company_id = ko.observable();
		this.department_id = ko.observable();
		this.selected_task_ids = ko.observableArray([]);


		this.placeholderText = ko.pureComputed(() => {
			const e = this.selected_employee();
			return e ? `Selected employee: ${e.firstname}${e.surname ? ` ${e.surname}` : ''} (${e.id_number ? ` ${e.id_number}` : `Emp. ID ${e.employee_id}`})` : "Search employee...";
		});

		this.search_string.subscribe((newValue) => {
			if (newValue != null && newValue != '' && newValue != undefined)
				this.dialog.get_employees();
			else
				this.employees([]);
		});

		this.selected_employee.subscribe((newValue) => {
			if (newValue != null)
				this.current_employee_id(newValue.employee_id);
			else
				this.current_employee_id(null);
		});
	}

	employee_click (selected)
	{
		this.selected_employee(selected);
		this.search_string('');
		this.employees([]);
	}

	clear_selected_option ()
	{
		this.selected_employee(null);
		this.search_string('');
		this.employees([]);
	}

	close()
	{
		this.dialog.close();
	}

	async save_entry()
	{
		let params = {
			department_id: this.dialog.bindings.department_id,
			employee_id: this.current_employee_id(),
			priority: this.priority(),
			editable: this.editable() ,
			approval_structure_line_id: this.approval_structure_line_id(),
			project_work_type_ids: this.task_id(),
			old_project_work_type_id: this.dialog.bindings.project_work_type_id  // Track which one we're replacing
		}

		if (!this.validate_entries())
			return;

		let res = await Grape.fetches.postJSON('time_management/edit_time_management_approval_structure_line', params);
		if (res.status == 'OK')
		{
			await Grape.alerts.alert({type: 'success', message: tr('Successfully edited entry.'), title: tr('Success', 'Success')});
			this.close();
		}
		else if (res.status == 'ERROR')
		{
			Grape.alerts.apiError(res);
			if (res?.code == 10)
			{
				document.getElementById('priority').focus();
				this.priority(this.dialog?.bindings?.priority || 1); 
			}
		}
		else
			Grape.alerts.alert({type: 'error',message: tr('Something went wrong...', 'Something went wrong...'),title: tr('Error', 'Error')});
	}

	toggle_task_selection(task)
	{
		if (this.selected_task_ids.indexOf(task.task_id) > -1) {
		    // If already selected, remove it
			this.selected_task_ids.remove(task.task_id);
		} else {
		    // If not selected, add it
			this.selected_task_ids.push(task.task_id);
		}
	}

	validate_entries()
	{
		let message = ''
		let valid = true;
		
		if (!this.current_employee_id())
		{
			message = 'Please select an employee for this structure line.';
			valid = false;
		}
		else if (!this.priority())
		{
			message = 'Priority must be provided.';
			valid = false;
		}
		else if (this.priority() <= 0)
		{
			message = 'Priority must be a positive number.';
			valid = false;
		}

		if (!valid)
		{
			Grape.alerts.alert({ type: 'error', message: message, title: tr('Error', 'Error') });
			return false;
		}
		return true;
	}
}

class AddApprovalStructurePage
{
	constructor (bindings)
	{
		this.viewModel = new AddApprovalStructureViewModel(this);
		this.bindings = bindings.row ? bindings.row : bindings ;
	}

	async init()
	{

		console.log('the bindings', this.bindings);
		//get company_id from department_id
		let res_company_id = await Grape.fetches.getJSON("/api/record", {
			table: "employee_department",
			schema: "public",
			filter: [{ value: this.bindings.department_id, operand: "=", field: "department_id" }],
		}); 

		if (res_company_id?.records)
			this.viewModel.company_id(res_company_id.records[0].company_id);

		//get projects
		let res_projects = await Grape.fetches.getJSON("/api/record", {
			table: "v_projects",
			schema: "savanna",
			filter: [{ value: this.viewModel.company_id(), operand: "=", field: "company_id" }],
		});

		//set bindings
		if (res_projects?.records)
		{
			for (let i = 0; i < res_projects.records.length; i++)
			{
				let record = res_projects.records[i];
				let userDescription = record.user_description || "None";
				record.task_description = `${record.task_description} (${userDescription})`;
			}

			this.viewModel.projects(res_projects.records);
			console.log('projects', this.viewModel.projects());
		}
		
		if (this.bindings.department_id)
			this.viewModel.department_id(this.bindings.department_id)

		console.log('department_id', this.viewModel.department_id());
		if (this.bindings && this.bindings.approval_structure_line_id)
		{
			this.viewModel.approval_structure_line_id(this.bindings.approval_structure_line_id)
			this.viewModel.priority(this.bindings.priority || '');
			this.viewModel.editable(this.bindings.editable); 
		}

		await this.get_employees();

		if (this.bindings.employee_id)
		{
			this.viewModel.current_employee_id(this.bindings.employee_id);
			this.viewModel.selected_employee(this.bindings);
		}
		else
			this.viewModel.current_employee_id(null);

		this.viewModel.employees([]);
		this.viewModel.search_string('');

		// Pre-select project/work type when editing
		if (this.bindings && this.bindings.project_work_type_id)
		{
			this.viewModel.task_id(this.bindings.project_work_type_id);
		}
	}

	async get_employees()
	{
		// Don't query the db if the search string is empty
		if (!this.viewModel.search_string() || this.viewModel.search_string().trim() === '')
		{
			this.viewModel.employees([]);
			return;
		}
	
		const search_string = this.viewModel.search_string().trim();
	
		try {
		
			let search_queries = [
				// Search by firstname
				Grape.fetches.getJSON('/api/record', {
					table: 'v_active_employees_department',
					schema: 'savanna',
					limit: 20,
					filter: [
						{ field: 'department_id', operand: '=', value: this.viewModel.department_id() },
						{ field: 'firstname', operand: 'ILIKE', value: `%${search_string}%` }
					]
				}),
				// Search by surname
				Grape.fetches.getJSON('/api/record', {
					table: 'v_active_employees_department',
					schema: 'savanna',
					limit: 20,
					filter: [
						{ field: 'department_id', operand: '=', value: this.viewModel.department_id() },
						{ field: 'surname', operand: 'ILIKE', value: `%${search_string}%` }
					]
				}),
				// Search by id_number
				Grape.fetches.getJSON('/api/record', {
					table: 'v_active_employees_department',
					schema: 'savanna',
					limit: 20,
					filter: [
						{ field: 'department_id', operand: '=', value: this.viewModel.department_id() },
						{ field: 'id_number', operand: 'ILIKE', value: `%${search_string}%` }
					]
				})
			];
		
			// Execute all search_queries in parallel for better performance
			let results = await Promise.all(search_queries);
		
			// Combine and deduplicate results using employee_id as key
			let employees_map = new Map();
			
			for (let res of results)
			{
				if (res.records && res.records.length > 0)
				{
					for (let record of res.records)
					{
						// Use employee_id as unique key to avoid duplicates
						if (!employees_map.has(record.employee_id))
						{
							employees_map.set(record.employee_id, record);
						}
					}
				}
			}
		
			let all_records = Array.from(employees_map.values());
		
			if (all_records.length > 0)
			{
				// Get employees with feature role
				let employees = await Grape.fetches.postJSON('/features/get_users_with_feature', {
					feature: 'TimeManagementApproval'
				});
			
				if (employees.result && employees.result.length > 0)
				{
					// Convert to Set for O(1) lookup
					const allowed_employee_ids = new Set(
						employees.result.map(str => parseInt(str))
					);
				
					// Filter, sort and map in one pass
					const final_employees = all_records
						.filter(record => allowed_employee_ids.has(record.employee_id))
						.sort((a, b) => {
							// Sort by firstname, then surname
							let compareFirst = (a.firstname || '').localeCompare(b.firstname || '');
							if (compareFirst !== 0) return compareFirst;
							return (a.surname || '').localeCompare(b.surname || '');
						})
						.slice(0, 50) // Limit final results to 50
						.map(record => ({
							...record,
							name: `${record.employee_id}#${record.firstname} ${record.surname || ''}`
						}));
					
					this.viewModel.employees(final_employees);
				}
				else
				{
					this.viewModel.employees([]);
				}
			}
			else
			{
				this.viewModel.employees([]);
			}
		}
		catch (error)
		{
			console.error('Error fetching employees:', error);
			this.viewModel.employees([]);
			Grape.alerts.alert({
				type: 'error',
				message: tr('Failed to load employees', 'Failed to load employees'),
				title: tr('Error', 'Error')
			});
		}
	}
}

export default {
	name: 'AddApprovalStructure',
	dialog_class: AddApprovalStructurePage,
	template: template,
	template_filename: 'translation/dialogs/add_approval_structure',
	provider: 'ps'
};
